var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Energy 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.924 53.7534L108.728 97.5572",
    stroke: "#E53A10",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.2211 34.0523C45.2211 34.0523 120.622 22.0293 108.726 97.5572C33.1981 109.454 45.2211 34.0523 45.2211 34.0523Z",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M152.528 56.3035L111.272 97.5572",
    stroke: "#E53A10",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M174.779 34.0523C174.779 34.0523 99.3777 22.0293 111.274 97.5572C186.802 109.454 174.779 34.0523 174.779 34.0523Z",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M105.29 129.635C106.519 122.617 107.782 111.894 108.268 96.2078H111.734C112.323 115.196 114.05 126.911 115.474 133.584C115.473 133.582 109.338 131.73 105.29 129.635Z",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M144.216 144.45L168.227 129.923C175.696 125.321 185.482 127.646 190.084 135.115C192.709 139.375 191.384 144.958 187.121 147.583L166.907 160.078L140.118 176.583C119.587 189.233 91.4064 189.644 71.3185 179.586C71.3185 179.586 52.4077 169.028 28.567 172.227V124.544L46.7115 114.49C66.9625 103.174 92.8364 122.406 92.8364 122.406C102.696 128.902 111.019 133.093 122.494 135.276C126.762 136.088 132.022 136.03 135.934 137.764C140.791 139.914 144.718 143.589 145.946 148.905C146.808 152.636 145.187 157.3 141.973 159.469C137.617 162.411 131.069 161.376 126.223 160.752C114.261 159.218 102.509 155.96 91.3147 151.508C91.1699 151.45 91.025 151.393 90.8784 151.334",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M134.856 137.342L160.923 122.06C167.528 117.99 176.182 120.045 180.25 126.65L180.961 128.185",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M119.783 134.759L149.618 117.154C155.595 113.47 163.249 114.803 167.666 119.984",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy1);
export default __webpack_public_path__ + "static/media/Energy 1.9d17e84ed291d5bf447706dd93235d17.svg";
export { ForwardRef as ReactComponent };